module.exports = __webpack_public_path__ + "static/media/ear.679f6b15.svg";